// extracted by mini-css-extract-plugin
module.exports = {"section":"_b5062060","content":"_75844100"};